import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, CircularProgress } from '@mui/material';
import SuccessScreen from 'screens/Questionnaire/components/form-submittion-state/SuccessScreen';
import VoiceAgent from 'screens/VoiceAgents/VoiceAgent';

// Lazy-loaded components
// const Questionnaire = lazy(() => import('../screens/Questionnaire/Questionnaire'));
// const SimpleConsentAndIntake = lazy(() => import('../screens/Questionnaire/SimpleConsentAndIntake'));
const FacebookAdCampaign = lazy(() => import('../screens/Questionnaire/FacebookAdCampaign'));
const MainLayout = lazy(() => import('../layout/mainLayout'));
const NotFound = lazy(() => import('../screens/NotFound'));

// Custom theme
const theme = createTheme({
  typography: {
    fontSize: 11, // 0.8rem
  },
});

const AppRoutes = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Suspense
        fallback={
          <div className='h-100 d-flex justify-content-center align-items-center'>
            <CircularProgress />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<NotFound />} />
          <Route path="/" element={<MainLayout />}>
            {/* <Route path="/ui/:tenantId/formLink/:formId" element={<Questionnaire />} /> */}
            {/* <Route path="/patient-intake" element={<Questionnaire />} /> */}
            <Route path="/patient-intake" element={<FacebookAdCampaign />} />
            <Route path="/success" element={<SuccessScreen />} />
            <Route path="/voice-agent" element={<VoiceAgent/>} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
};

export default AppRoutes;
